import useAutomaticallyOpenOnboardingPopup from '@beatgig/auth-hooks/use-automatically-open-onboarding-popup'

export function AutomaticallyOpenAuthPopup() {
  useAutomaticallyOpenOnboardingPopup()
  return <></>
}
